export const PROFILE_ACTION = {
    RESET_PROFILE_STATE: 'RESET_PROFILE_STATE',
    REQUEST_PROFILE: 'REQUEST_PROFILE',
    PROFILE_ERROR: 'PROFILE_ERROR',
    PROFILE_RESPONSE: 'PROFILE_RESPONSE',

    RESET_UPDATE_PROFILE_FOR_USER:'RESET_UPDATE_PROFILE_FOR_USER',
    REQUEST_UPDATE_PROFILE_FOR_USER:'REQUESTUPDATE_PROFILE_FOR_USER',
    RESPONSE_UPDATE_PROFILE_FOR_USER:'RESPONSE_UPDATE_PROFILE_FOR_USER',
    ERROR_UPDATE_PROFILE_FOR_USER:'ERROR_UPDATE_PROFILE_FOR_USER'
  };

  export const setResetStatePROFILE = () => ({
    type: PROFILE_ACTION.RESET_PROFILE_STATE,
    data: undefined
  });
  
  export const requestProfileAction = (params) =>({
    type:PROFILE_ACTION.REQUEST_PROFILE,
    data: params
  })
  export const responseProfileAction = (res) => ({
    type: PROFILE_ACTION.PROFILE_RESPONSE,
    data: res
  });
  
  export const errorProfileAction = (err) => ({
    type: PROFILE_ACTION.PROFILE_ERROR,
    data: err
  });
  
  export const setResetUpdateProfiileForUser = () => ({
    type: PROFILE_ACTION.RESET_UPDATE_PROFILE_FOR_USER,
    data: undefined
  });
  
  export const requestUpdateProfileForUser = (params) =>({
    type:PROFILE_ACTION.REQUEST_UPDATE_PROFILE_FOR_USER,
    data: params
  })
  export const responseUpdateProfileForUser = (res) => ({
    type: PROFILE_ACTION.RESPONSE_UPDATE_PROFILE_FOR_USER,
    data: res
  });
  
  export const errorUpdateProfileForUser = (err) => ({
    type: PROFILE_ACTION.ERROR_UPDATE_PROFILE_FOR_USER,
    data: err
  });

